import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '../../../types';

const headerCurrencyConverterStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(1),
        position: 'relative',
        direction: 'rtl' as any,
        '@media (max-width: 600px)': {
            marginLeft: theme.spacing(0.5),
            marginRight: theme.spacing(0.5)
        }
    },
    rateLabel: {
        direction: 'ltr' as any,
        color: theme.palette.text.secondary,
        fontSize: '0.8rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        marginLeft: theme.spacing(1.5),
        height: 32,
        lineHeight: '32px',
        '@media (max-width: 600px)': {
            display: 'none'
        }
    },
    /* Sliding panel */
    panel: {
        direction: 'ltr' as any, // restore normal text direction inside panel
        display: 'flex',
        alignItems: 'center',
        overflowX: 'clip' as any,
        overflowY: 'visible' as any,
        transition: 'max-width 0.3s ease, opacity 0.25s ease',
        whiteSpace: 'nowrap'
    },
    panelOpen: {
        maxWidth: 600,
        opacity: 1
    },
    panelClosed: {
        maxWidth: 0,
        opacity: 0,
        pointerEvents: 'none'
    },
    /* Form fields — shared vertical-alignment fix */
    converterField: {
        height: 32,
        margin: '0 !important',
        marginLeft: '6px !important',
        '& .MuiInputBase-root': {
            height: 32
        },
        // The bar's controls share one faint outline, so they read as a quiet
        // group rather than a row of separate buttons.
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.25) !important'
        },
        '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.38) !important'
        }
    },
    currencySelect: {
        width: 80,
        '& .MuiSelect-root': {
            fontSize: '0.8rem'
        }
    },
    amountInput: {
        width: 90,
        marginLeft: 2,
        '& input': {
            fontSize: '0.8rem'
        }
    },
    resultInput: {
        width: 100,
        marginLeft: 2,
        '& input': {
            fontWeight: 600
        }
    },

    swapBtn: {
        height: 32,
        width: 32,
        padding: 0,
        margin: theme.spacing(0, 0.75),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.secondary,
        '&:hover': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.action.hover
        }
    },
    toggleBtn: {
        height: 32,
        width: 32,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Subtle glass, the bar's own material: a faint see-through fill and
        // the same outline as the fields beside it — no colour of its own.
        backgroundColor: 'rgba(255,255,255,0.12)',
        border: '1px solid rgba(255,255,255,0.25)',
        borderRadius: 8,
        color: theme.palette.common.white,
        '&:hover': { backgroundColor: 'rgba(255,255,255,0.20)' }
    },
    toggleIcon: {
        fontSize: '1.2rem'
    },
    swapIcon: {
        fontSize: '1.2rem'
    }
}));

export default headerCurrencyConverterStyles;
